const config = {
    AUTOMATION_ID: 'test-automation-save-for-later-product-cartridge',
    DISPLAYED_PRODUCT_NUMBER: 11,
    productCartridgeProps: {
        pageType: 'cart',
        slotId: 'cart_save_for_later',
        loader: 'getAllSaveForLater',
        attributes: {
            productCardType: 'saveForLater',
        },
        customRenderProductCard: true,
    },
};

export default config;
